import { render, staticRenderFns } from "./select-refund-address.vue?vue&type=template&id=2b8eb283&scoped=true"
import script from "./select-refund-address.vue?vue&type=script&lang=ts"
export * from "./select-refund-address.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8eb283",
  null
  
)

export default component.exports